import debug from "debug";

// import plugin from '../../lib/plugin';

const MODULE_NAME = 'app.core/modules/accordion-radio-toggle';
const log = debug(MODULE_NAME);

const TOGGLE_ELEMENT_SELECTOR = '[data-accordion-radio-toggle]';
const TOGGLE_CLASS_NAME = 'data-accordion-radio-toggle-class-name';
const TOGGLE_CLASS_ELEMENT = 'data-accordion-radio-toggle-element';
const TOGGLE_CLASS_ACTION = 'data-accordion-radio-toggle-class-action';

function toggleClass($trigger) {
	const name = $trigger.attr('name');
	const classname = $trigger.attr(TOGGLE_CLASS_NAME);
	const isChecked = $trigger.is(':checked');
	const toggleClassElement = $trigger.attr(TOGGLE_CLASS_ELEMENT);
	const toggleClassAction = $trigger.attr(TOGGLE_CLASS_ACTION);

	$('[name="'+name+'"]').each(function(){
		var removeClassElement = $(this).attr(TOGGLE_CLASS_ELEMENT);
		$(removeClassElement).removeAttr('aria-expanded');
		if (toggleClassAction == 'remove') {
			$(removeClassElement).addClass(classname);
		}
		else {
			$(removeClassElement).removeClass(classname);
		}
	});

	if (isChecked) {
		if (toggleClassAction == 'remove') {
			$(toggleClassElement).removeClass(classname);
		}
		else {
			$(toggleClassElement).addClass(classname);
		}
		$(toggleClassElement).attr('aria-expanded', true);
	}
}

function toggleOnKeyPress($trigger) {
	$trigger.attr('checked', 'checked');
	toggleClass($trigger);
}

export function exec() {
	$(TOGGLE_ELEMENT_SELECTOR).on('change', function() {
		toggleClass($(this));
	});

	$(TOGGLE_ELEMENT_SELECTOR).on('keypress', function(event) {
		var keycode = event.keyCode || event.which;
		// detect space or enter keypress
		if (keycode == 13 || keycode== 32) {
			toggleOnKeyPress($(this));
		}
	});
}



// WEBPACK FOOTER //
// ./client/src/core/modules/accordion-radio-toggle/index.js